import { render, staticRenderFns } from "./ship-chat.vue?vue&type=template&id=98ef60d0&scoped=true"
import script from "./ship-chat.vue?vue&type=script&lang=js"
export * from "./ship-chat.vue?vue&type=script&lang=js"
import style0 from "./ship-chat.vue?vue&type=style&index=0&id=98ef60d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef60d0",
  null
  
)

export default component.exports